import React, { useState } from "react";
import Step from "./Step";
import { ethers } from "ethers";
import StepButton from "./StepButton";

const MANDALA_PARAMS = {
  chainId: "0x253",
  chainName: "Mandala TC7",
  nativeCurrency: {
    name: "Acala",
    symbol: "ACA",
    decimals: 18,
  },
  rpcUrls: ["https://tc7-eth.aca-dev.network"],
  blockExplorerUrls: null,
};

interface Step2Props {
  currentStep: number;
  stepComplete: (address: string) => void;
}

const Step2: React.FC<Step2Props> = ({ currentStep, stepComplete }) => {
  const [loading, setLoading] = useState(false);
  const provider = new ethers.providers.Web3Provider((window as any).ethereum);

  return (
    <Step
      stepNum={2}
      currentStep={currentStep}
      title="Connect Your EVM Account"
    >
      <div className="flex flex-col justify-center items-start gap-2 py-3">
        <StepButton
          text="Connect"
          completedText="Connected"
          completed={currentStep > 2}
          onClick={async () => {
            setLoading(true);
            try {
              const { chainId } = await provider.getNetwork();

              if (chainId !== 595) {
                await provider.send("wallet_addEthereumChain", [
                  MANDALA_PARAMS,
                ]);
              }

              const accounts = await provider.send("eth_requestAccounts", []);
              stepComplete(accounts[0]);
            } catch {}

            setLoading(false);
          }}
          disabled={currentStep !== 2}
          loading={loading}
        />
      </div>
    </Step>
  );
};

export default Step2;
